<div class="container" fxLayout="column">
  <div class="breadcrumb">
    <p>
    <a [routerLink]="'/dashboard'" class="breadcrumb-link">Home</a> /
    <span>OTA Upgrade</span> 
    </p>
  </div>  
  <div fxLayout="row" fxLayoutGap="30">
    <div fxFlex="30">
      <mat-card >
        <form [formGroup]="fileUploadForm" (submit)="onFileSubmit()" enctype="multipart/form-data">
          <div fxLayout="column" class="ota-container" fxLayoutGap="10">
            <mat-form-field appearance="outline" class="custom-input-field">
              <mat-label>Model</mat-label>
              <mat-select placeholder="Select Model" formControlName="selectedModel">
                <mat-option value="WLD4">WLD4</mat-option>
                  <mat-option value="WLD5">WLD5</mat-option>
                  <mat-option value="WLD_OTA_TEST44">WLD_OTA_TEST44</mat-option>
                  <mat-option value="WLD_OTA_TEST49">WLD_OTA_TEST49</mat-option>
                  <mat-option value="WLD3">WLD3</mat-option>
                  <mat-option value="WLDTEST3">WLDTEST3</mat-option>
                  <mat-option value="WLD_OTA_TEST42">WLD_OTA_TEST42</mat-option>
                  <mat-option value="WLD_OTA_TEST46">WLD_OTA_TEST46</mat-option>
                  <mat-option value="WLD2">WLD2</mat-option>
                  <mat-option value="WD-EWDSP32"></mat-option>
                  <mat-option value="WLD_OTA_TEST55">WLD_OTA_TEST55</mat-option>
                  <mat-option value="WLD_SEETA">WLD_SEETA</mat-option>
                  <mat-option value="WLDTEST1">WLDTEST1</mat-option>
                  <mat-option value="WLD_Va">WLD_Va</mat-option>
                  <mat-option value="WLD_OTA_TEST54">WLD_OTA_TEST54</mat-option>
                  <mat-option value="WLD_OTA_TEST43">WLD_OTA_TEST43</mat-option>
                  <mat-option value="WLD_OTA_TEST45">WLD_OTA_TEST45</mat-option>
                  <mat-option value="WLD_OTA_TEST41">WLD_OTA_TEST41</mat-option>
                  <mat-option value="WLDTEST4">WLDTEST4</mat-option>
                  <mat-option value="CO2D">CO2D</mat-option>
                  <mat-option value="WLD">WLD</mat-option>
                  <mat-option value="WLDTEST">WLDTEST</mat-option>
              </mat-select>
            </mat-form-field>
  
                <mat-form-field appearance="outline" class="custom-input-field">
                  <mat-label>Firmware Version</mat-label>
                  <input matInput formControlName="versionNo" placeholder="firmware version" class="OTA-font" required>
                  <mat-error *ngIf="fileUploadForm.get('versionNo')?.hasError('required') && fileUploadForm.get('versionNo')?.touched">
                    Firmware version Value is required.
                  </mat-error>
                </mat-form-field>
    
                  <mat-form-field appearance="outline" class="custom-input-field">
                    <mat-label>Job Name</mat-label>
                    <input matInput formControlName="extractedName" placeholder="Job name" class="OTA-font" required>
                    <mat-error *ngIf="fileUploadForm.get('extractedName')?.hasError('required') && fileUploadForm.get('extractedName')?.touched">
                      Job Name is required.
                    </mat-error>
                  </mat-form-field>
    
                    <mat-form-field appearance="outline" class="custom-input-field">
                      <mat-label>Description</mat-label>
                      <textarea matInput formControlName="Description" placeholder="Job Description" class="OTA-font" required></textarea>
                      <mat-error *ngIf="fileUploadForm.get('Description')?.hasError('required') && fileUploadForm.get('Description')?.touched">
                        Description is required.
                      </mat-error>
                    </mat-form-field>
    
                      <mat-card-title>Upload OTA</mat-card-title>
                      <mat-form-field class="custom-input-field">
                        <ngx-mat-file-input [accept]="'.bin'" name="file" placeholder="Binary file only" (change)="onFileSelection($event)"></ngx-mat-file-input>
                        <mat-icon matSuffix>folder</mat-icon>
                      </mat-form-field>
    
                          <div fxLayoutAlign="end center">
                            <button mat-raised-button color="primary" type="submit" [disabled]="!selectedFile || fileUploadForm.invalid">
                              Create OTA Job
                            </button>
                          </div>
            </div>
        </form>
      </mat-card>
    </div>
     <div fxFlex="70" >
        <app-list-ota></app-list-ota>
     </div>
  </div>
</div>